import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import cogoToast from 'cogo-toast';
import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { CHANGE_VEHICLE, CHANGE_VEHICLE_ERROR, CHANGE_VEHICLE_SUCCESS } from '../../../actions.js';

function* changeVehicle({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/bookings/${payload?.id}/change-vehicle`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: {
        ...payload?.data,
      },
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message || 'Vehicle allocation updated');
      yield put({
        type: CHANGE_VEHICLE_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message || 'Failed to update vehicle allocation');
      yield put({
        type: CHANGE_VEHICLE_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: CHANGE_VEHICLE_ERROR, payload: error });
  }
}

export function* watchChangeVehicle() {
  yield takeEvery(CHANGE_VEHICLE, changeVehicle);
}

function* changeVehicleSaga() {
  yield all([fork(watchChangeVehicle)]);
}

export default changeVehicleSaga;
